/*eslint-disable */
import React, { Component, useEffect } from "react";
import { useState } from "react";
import { Table, Grid, Icon, Button } from "semantic-ui-react";
import FormikCreateLrSeries from "./createLrSeries";
import ReadAxios from "../axiosComponent/read";
import DeleteModal from "../vendor-login/ordersComponent/bill/modals/deleteModal";
import DeleteAxios from "../axiosComponent/delete";
import cogoToast from "cogo-toast";
import {LR_SERIES} from './branchConstants'
const LrSeriesTable = ({branchId, branchCode,LrSeriesData, ...props})=> {

  const [openCreateModal, setOpenCreateModal] = useState(false)
  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [currentSeriesId, setCurrentSeriesId] = useState("")

  const openLRSeriesCreateModal = ()=>{
    setOpenCreateModal(true)
  }
  const closeLRSeriesCreateModal = ()=> {
    setOpenCreateModal(false)
  }
  const openLrSeriesDeleteModal = (lrSeriesId)=>{
    setCurrentSeriesId(lrSeriesId)
    setOpenDeleteModal(true)
  }
  const closeLrSeriesDeleteModal = ()=>{
    setOpenDeleteModal(false)
  }
  const deleteLrSeries = ()=>{
    if(currentSeriesId){
      DeleteAxios({url:`branchLrSeriesMapping`, uniqueId:currentSeriesId}).then((res)=>{
        if(res.data.status===200){
          cogoToast.success(res?.data?.message, {position:"top-right"});
            setTimeout(()=>{
                window.location.reload()
            },1000)
        }else{
          cogoToast.error(res?.data?.message, {position:"top-right"});
        }
      }).catch((err)=>{
        console.log(err);
        cogoToast.error(err?.response?.data?.message, {position:"top-right"})
      })
    }
  }

    return (
      <>
          <div>
            <Table stackable size="small" selectable className="mb-5">
              <Table.Header className="w3-small">
                <Table.Row>
                  <Table.HeaderCell colSpan="6" className="p-bold-600">
                    {LR_SERIES.titles.table_heading||"LR SERIES"}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-600" textAlign="right">
                    <Button
                      type="button"
                      className="w3-button w3-blue w3-small w3-round w3-hover-blue"
                      add_mode="add"
                      onClick={openLRSeriesCreateModal}
                    >
                      <Icon name="plus" /> {LR_SERIES.buttons.add||"Add"}
                    </Button>
                  </Table.HeaderCell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell className="p-bold-500">
                    {LR_SERIES.table_headers.prefix||"Series Prefix"}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {LR_SERIES.table_headers.special_charecter||"Special Charecter"}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {LR_SERIES.table_headers.date_format||"Date Format"}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {LR_SERIES.table_headers.lr_start||"LR Starting From"}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {LR_SERIES.table_headers.lr_end||"LR Ending In"}
                  </Table.HeaderCell>
                  <Table.HeaderCell className="p-bold-500">
                    {LR_SERIES.table_headers.series_type||"Series Type"}
                  </Table.HeaderCell>

                  <Table.HeaderCell className="p-bold-500">
                      {LR_SERIES.buttons.delete||'Delete'}
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              {LrSeriesData && LrSeriesData.length > 0 ? (
                LrSeriesData.map((object, index) => (
                  <Table.Row key={index}>
                    <Table.Cell>{object.seriesPrefix||"NA"}</Table.Cell>
                    <Table.Cell>{object.specialCharacter||"NA"}</Table.Cell>
                    <Table.Cell>{object.dateFormat || "NA"}</Table.Cell>
                    <Table.Cell>{object.lrFirst || "NA"}</Table.Cell>
                    <Table.Cell>{object.lrLast || "NA"}</Table.Cell>
                    <Table.Cell>{object.seriesType || "NA"}</Table.Cell>
                    <Table.Cell><Button type="button" disabled={object.hasStartedUsing && Number(object.hasStartedUsing)===1 ? true : false}  
                    user_items={object} add_mode="delete" onClick={()=>openLrSeriesDeleteModal(object.branchLrSeriesMappingId)} size="mini" color="red" basic icon> <Icon name="trash" /> </Button></Table.Cell>
                  </Table.Row>
                ))
              ) : (
                <Table.Row>
                  <Table.Cell colSpan="6">{"No Record(s) Found"}</Table.Cell>
                </Table.Row>
              )}
            </Table>

            <DeleteModal open={openDeleteModal} onClose={closeLrSeriesDeleteModal} handleDelete={deleteLrSeries} />
            <FormikCreateLrSeries OpenModal={openCreateModal} CloseModal={closeLRSeriesCreateModal} branchId={branchId} branchCode={branchCode}/>
          </div>
      </>
    );
}

export default LrSeriesTable ;
